export default "__VITE_ASSET__BBmB6btF__"